import React, { useState } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";

const HEADERS = [
  "FEEMONTH",
  "CAMPUS",
  "ROLLNUMBER",
  "CHALLANNUMBER",
  "STUDENTNAME",
  "FATHERNAME",
  "STANDARDCLASS",
  "MONTHLYQUARTERLY",
  "TUTIONFEE",
  "LATEPAYCHARGES",
  "MISCCHARGES",
  "OTHERS",
  "TAXAMOUNT",
  "FEEBEFOREDUEDATE",
  "DUEDATE",
  "FEEAFTERDUEDATE",
];

const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const formatFeeMonth = (date) => {
  const [year, month] = String(date || "")
    .slice(0, 10)
    .split("-");
  const monthName = MONTH_NAMES[Number(month) - 1];

  return year && monthName ? `${monthName}-${year.slice(-2)}` : "";
};

const formatDueDate = (date) => {
  const [year, month, day] = String(date || "")
    .slice(0, 10)
    .split("-");
  return year && month && day ? `${day}-${month}-${year}` : "";
};

const formatAmount = (amount) => {
  const value = Number(amount);
  return Number.isFinite(value) ? value.toFixed(2) : "0.00";
};

const getChallanFeeMonth = (challan) => {
  const months = (challan.fee_challan_details || [])
    .map((detail) => detail.fee_month)
    .filter(Boolean)
    .sort();

  return formatFeeMonth(months[months.length - 1]);
};

const DueFeeBankExport = ({ printData }) => {
  const [tableElement, setTableElement] = useState(null);

  return (
    <div>
      <DownloadTableExcel
        filename="Bank Student Due Fee Report"
        sheet="Bank Student Due Fee Report"
        currentTableRef={tableElement}
      >
        <button className="btn btn-primary mt-4" disabled={!tableElement}>
          Bank Export
        </button>
      </DownloadTableExcel>

      <table ref={setTableElement} style={{ width: "100%", display: "none" }}>
        <thead>
          <tr>
            {HEADERS.map((header) => (
              <td key={header}>{header}</td>
            ))}
          </tr>
        </thead>

        <tbody>
          {(printData || []).map((student) =>
            (student.fee_challans || []).map((challan) => {
              const amount = formatAmount(challan.payable);

              return (
                <tr key={`${student.id}-${challan.id}`}>
                  <td>{getChallanFeeMonth(challan)}</td>
                  <td>{student.campus?.name || ""}</td>
                  <td>
                    {student.admission_id || student.registration_id || ""}
                  </td>
                  <td>{challan.challan_no || ""}</td>
                  <td>{student.name || ""}</td>
                  <td>{student.father_name || ""}</td>
                  <td>{student.student_class?.name || ""}</td>
                  <td>MONTHLY</td>
                  <td>{amount}</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>0.00</td>
                  <td>{amount}</td>
                  <td style={{ msoNumberFormat: "\\@" }}>
                    {formatDueDate(challan.due_date)}
                  </td>
                  <td>{amount}</td>
                </tr>
              );
            }),
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DueFeeBankExport;
